import { render, staticRenderFns } from "./BKSvgIcon.vue?vue&type=template&id=80fac964&scoped=true"
import script from "./BKSvgIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./BKSvgIcon.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BKSvgIcon.vue?vue&type=style&index=0&id=80fac964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fac964",
  null
  
)

export default component.exports